module.exports = __webpack_public_path__ + "static/media/haze-weather_200_transparent.bb308ea9.gif";